import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "errorWrapper",
  hidden: "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<div id=\"errorMessageRight\"><button id=\"errorClose\" data-l10n-id=\"error_close\" class=\"pdf-button-close\"> × </button></div><div id=\"errorMessageLeft\"><span id=\"errorMessage\"></span><button id=\"errorShowMore\" data-l10n-id=\"error_more_info\" class=\"pdf-button-more-information\"> Mas Información </button><button id=\"errorShowLess\" data-l10n-id=\"error_less_info\" hidden=\"true\" class=\"pdf-button-more-information\"> Menos Información </button></div><div class=\"clearBoth\"></div><textarea id=\"errorMoreInfo\" hidden=\"true\" readonly></textarea>", 4)
  ]), 512)), [
    [_vShow, _ctx.showElem('errorWrapper')]
  ])
}